export const replaceInTemplate = (text, placeholder, value) => text.split(`{{${placeholder}}}`).join(value);
//# sourceMappingURL=replace-in-template.js.map